import { render, staticRenderFns } from "./Nl.vue?vue&type=template&id=f8008478"
import script from "./Nl.vue?vue&type=script&lang=js"
export * from "./Nl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports